import React from "react";

import FileMedium from "../FileMedium/FileMedium";

const fileGridView = (props) => {
  // GET contents of folder with FolderId and assign them to fileItems
  // const folderId = props.match.params.folderId;
  // let navLinkTo;

  let subFolderId = props.match.params.subId;

  // subFolderId
  //   ? (navLinkTo = "/documents")
  //   : (navLinkTo = "/files/".concat(props.match.params.folderId));
  return (
    <div className="flex-wrap d-flex">
      {props.fileItems.map((item) => (
        <FileMedium
          key={item.id || item.folderId}
          item={item}
          folderId={item.folderId}
          title={item.title}
          lastOpenedValue={item.lastOpenedValue}
          lastOpenedUnit={item.lastOpenedUnit}
          color={props.isSearchDocuments || subFolderId ? "" : item.color.id}
          pinned={props.pinned ? props.pinned[item.id] : false}
          checked={props.checked ? props.checked[item.id] : false}
          checkedHandler={() => props.checkHandler(item.id)}
          pinHandler={() =>
            props.pinHandler(
              item.folderId,
              props.pinned[item.folderId],
              item.title,
              item.parentFolder.id
            )
          }
          hoverId={props.hoverId}
          isColumns={props.isColumns ? props.isColumns : {}}
          isFolder={props.isFolder}
          isDocuments={props.isDocuments}
          isDocumentView={props.isDocumentView}
          pinOverHandler={() => props.pinOverHandler(item.folderId)}
          pinOutHandler={() => props.pinOutHandler(item.folderId)}
          onClick={props.onClick}
          rootFolderId={
            item["__typename"] === "FolderType"
              ? item.parentFolder
                ? item.parentFolder.id
                : item.folderId
              : item.__typename === "DocumentType"
              ? item.folder.parentFolder.id
              : null
          }
          subFolderId={"parentFolder" in item ? item.folderId : item.folder.id}
          setEditFolder={props.setEditFolder}
          documentOnClickHandler={props.documentOnClickHandler}
          setShareFolder={props.setShareFolder}
          setMoveFileModalVisibility={props.setMoveFileModalVisibility}
          setArchiveModalVisibility={props.setArchiveModalVisibility}
          currentUserInfo={props.currentUserInfo}
          userRoleId={props.userRoleId}
        />
      ))}
    </div>
  );
};

export default fileGridView;
